import {LatLngBounds, Map} from 'leaflet';
import {useEffect} from 'react';
import {useMap} from 'react-leaflet';
import {SWE_BOUNDING_BOX} from '../../../services/geo/constants';

declare class MapWithExtendedArea extends Map {
    setActiveArea(selector: string): void;
}

interface MapActiveAreaProps {
    mapBounds?: LatLngBounds | null;
    listVisible?: boolean;
}

export function MapActiveArea({mapBounds, listVisible}: MapActiveAreaProps) {
    const map = useMap() as MapWithExtendedArea;

    useEffect(() => {
        map.setActiveArea('map_active_area');
        map.fitBounds(SWE_BOUNDING_BOX);
    }, [map]);

    useEffect(() => {
        if (!mapBounds) {
            return;
        }
        // Extra padding when list_modal is opened to make sure markers are not hidden
        const padding: [number, number] = listVisible ? [10, 50] : [10, 10];
        map.flyToBounds(mapBounds, {duration: 0.8, easeLinearity: 0.25, padding});
    }, [mapBounds, listVisible, map]);

    return null;
}
